import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import {
  StyledWrapper,
  LinkButtonWrapper,
  ThemeLanguageSwitchWrapper,
  StyledExitToAppIcon,
} from './Navbar.styled';
import { adminUserService } from '../../services';
import LinkButton from '../button/LinkButton';
import HomeButton from '../button/HomeButton';
// import DrawerNavbar from './drawer';
import { DrawerNavbar, DropdownButton } from './components';
import ThemeSwitch from '../button/ThemeSwitch';
import LanguageSelect from '../button/LanguageSelect';
import { baseUrl } from '../../config/baseUrl';

const Navbar = (props) => {
  const [currentPath, setCurrentPath] = useState('');
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const isSignIn = localStorage.getItem('token');

  useEffect(() => {
    const tempPath = window.location.pathname.split('/');
    setCurrentPath(tempPath[2]);
  }, []);

  const handleClickSignOut = () => {
    adminUserService.signOut();
  };

  return (
    <StyledWrapper>
      <Hidden mdUp>
        <IconButton
          color='inherit'
          onClick={() => {
            setIsOpenDrawer(true);
          }}
        >
          <MenuIcon fontSize='large' />
        </IconButton>
        <DrawerNavbar
          open={isOpenDrawer}
          onClose={() => {
            setIsOpenDrawer(false);
          }}
          currentPath={currentPath}
        />
      </Hidden>
      <HomeButton />
      <LinkButton to={baseUrl} active={!currentPath}>
        Home
      </LinkButton>
      <Hidden smDown>
        <LinkButtonWrapper>
          <LinkButton
            to={`${baseUrl}mobile-app`}
            active={currentPath === 'mobile-app'}
          >
            Utraffic Mobile
          </LinkButton>
          <LinkButton href='https://bktraffic.com/utraffic/'>
            Utraffic Website
          </LinkButton>
          <LinkButton href='https://bktraffic.com/'>
            VoH Website
          </LinkButton>
          <LinkButton
            to={`${baseUrl}public-data`}
            active={currentPath === 'public-data'}
          >
            Public Data
          </LinkButton>
          <LinkButton
            active={currentPath?.includes('collect-data')}
            to={`${baseUrl}collect-data`}
          >
            Collect Data
          </LinkButton>
          <LinkButton
            active={currentPath?.includes('admin')}
            to={`${baseUrl}admin`}
          >
            Admin
          </LinkButton>
          <DropdownButton
            label='Documents'
            active={
              currentPath === 'publications' ||
              currentPath === 'publications/thesis' ||
              currentPath?.includes('apis')
            }
          >
            <LinkButton
              active={
                currentPath === 'publications' ||
                currentPath === 'publications/thesis'
              }
              to={`${baseUrl}publications`}
              isInDropdown
            >
              Publications
            </LinkButton>
            <LinkButton
              active={currentPath?.includes('apis')}
              to={`${baseUrl}apis/intro`}
              isInDropdown
            >
              APIS
            </LinkButton>
          </DropdownButton>
          {/* <LinkButton active={currentPath === 'publications' || currentPath === 'publications/thesis'} to={`${baseUrl}publications`}>Publications</LinkButton>
          <LinkButton active={currentPath?.includes('apis')} to={`${baseUrl}apis/intro`}>APIS</LinkButton> */}
          <ThemeLanguageSwitchWrapper>
            <LanguageSelect />
            <ThemeSwitch />
            {isSignIn && currentPath && currentPath.includes('admin') && (
              <StyledExitToAppIcon onClick={handleClickSignOut} />
            )}
          </ThemeLanguageSwitchWrapper>
        </LinkButtonWrapper>
      </Hidden>
    </StyledWrapper>
  );
};

Navbar.propTypes = {};

export default Navbar;
